import React from 'react'
import {
  DialogWindow,
  DialogHeader,
  DialogAdornment,
  ContentTransition,
  useDialog,
} from '@ticketswap/solar'
import { withTranslation } from '~/i18n'
import Feedback from './Feedback'
import PositiveConfirm from './PositiveConfirm'
import NegativeConfirm from './NegativeConfirm'
import { CloseAlt } from '@ticketswap/comets'

function FeedbackDialog({ t, children, ...props }) {
  const [title, setTitle] = React.useState('')
  const [activeView, setActiveView] = React.useState('feedback')
  const { hide, getToggleProps, getWindowProps } = useDialog()

  return (
    <>
      {children({ getToggleProps, setActiveView, hide })}
      <DialogWindow {...getWindowProps()}>
        <DialogHeader>
          {title}
          <DialogAdornment right>
            <button onClick={hide}>
              <CloseAlt size={24} />
            </button>
          </DialogAdornment>
        </DialogHeader>
        <ContentTransition
          onChange={item => {
            setTitle(item.props.title)
          }}
          activeView={activeView}
        >
          <Feedback
            key="feedback"
            t={t}
            hide={hide}
            title={t('common:feedbackDialog.title')}
            setActiveView={setActiveView}
          />
          <PositiveConfirm
            key="positive-confirm"
            t={t}
            hide={hide}
            title={t('common:feedbackDialog.confirm.title')}
          />
          <NegativeConfirm
            key="negative-confirm"
            t={t}
            hide={hide}
            title={t('common:feedbackDialog.confirm.title')}
          />
        </ContentTransition>
      </DialogWindow>
    </>
  )
}

export default withTranslation('common')(FeedbackDialog)
